'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';
import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PaginationPluto from './Pagination';
import { useState } from 'react';
import { useEffect } from 'react';

import PlutoMenu from './PlutoMenu';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';
import ChartComp2 from './ChartComp2';

function PlutoChargebacks() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const [type, setType] = useState(0)
    const [selectedMonth, setSelectedMonth] = useState(-1)
    const [grouppedCb, setGrouppedCb] = useState(true)
    const [chargebackData, setChargebackData] = useState(undefined)
    const [chargebackDataWalls, setChargebackDataWalls] = useState(undefined)
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    useEffect(() => {
        socket.on('response_get_admin_chargeback', (data) => {
            setChargebackData(data.dataMonthCB)
            setChargebackDataWalls(data.wallChargebackData)
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 10))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
        })

        socket.emit('getChargebacksAdmin', {
            offers_like: username,
            page,
            groupped: grouppedCb,
            type: type
        })
    }, [])

    const styles = {
        pageContainer: {
            color: '#e6edf3',
            marginTop: '20px',
            padding: '24px',
            background: '#0d1117',
            minHeight: '100vh',
        },
        filterButtonRow: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            gap: '10px',
            marginBottom: '16px',
        },
        filterButton: (isActive) => ({
            padding: '8px 16px',
            borderRadius: '8px',
            border: isActive ? '1px solid #2ea043' : '1px solid #30363d',
            background: isActive ? '#238636' : '#161b22',
            color: isActive ? '#ffffff' : '#c9d1d9',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            minWidth: '100px',
            textAlign: 'center',
        }),
        groupButton: (isActive) => ({
            padding: '8px 16px',
            borderRadius: '8px',
            border: isActive ? '1px solid #2ea043' : '1px solid #30363d',
            background: isActive ? '#238636' : '#161b22',
            color: isActive ? '#ffffff' : '#c9d1d9',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            marginTop: '12px',
            marginBottom: '12px',
            minWidth: '100px',
            textAlign: 'center',
        }),
        select: {
            maxWidth: '300px',
            width: '100%',
            height: '36px',
            backgroundColor: '#0d1117',
            color: '#e6edf3',
            border: '1px solid #30363d',
            borderRadius: '8px',
            padding: '0 10px',
            fontSize: '13px',
            marginTop: '12px',
            outline: 'none',
        },
        statsRow: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '16px',
            marginTop: '20px',
            marginBottom: '20px',
        },
        statCard: {
            background: '#161b22',
            border: '1px solid #21262d',
            borderLeft: '3px solid #f85149',
            borderRadius: '12px',
            padding: '16px 24px',
            minWidth: '160px',
        },
        statValue: {
            fontSize: '22px',
            fontWeight: '700',
            color: '#e6edf3',
            margin: '0 0 4px 0',
        },
        statLabel: {
            fontSize: '12px',
            color: '#8b949e',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
        tableContainer: {
            overflow: 'auto',
            margin: '0 auto',
            padding: '20px',
            marginBottom: '20px',
            background: '#161b22',
            border: '1px solid #21262d',
            borderRadius: '12px',
        },
        tableTitle: {
            color: '#e6edf3',
            fontWeight: 'bold',
            fontSize: '16px',
            marginBottom: '16px',
        },
        searchInput: {
            borderRadius: '8px',
            background: '#0d1117',
            border: '1px solid #30363d',
            marginBottom: '12px',
            color: '#e6edf3',
            fontSize: '13px',
            padding: '8px 12px',
            width: '100%',
            maxWidth: '400px',
            outline: 'none',
        },
        tableHeaderRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #21262d',
            background: '#161b22',
        },
        tableHeaderCell: (minWidth) => ({
            minWidth,
            fontSize: '11px',
            fontWeight: '600',
            color: '#8b949e',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
        }),
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #21262d',
            color: '#c9d1d9',
            fontSize: '13px',
        },
        tableCell: (minWidth, extra) => ({
            minWidth,
            color: '#c9d1d9',
            fontSize: '13px',
            ...extra,
        }),
        tableCellPrimary: (minWidth) => ({
            minWidth,
            textAlign: 'left',
            color: '#e6edf3',
            fontWeight: '500',
            fontSize: '13px',
        }),
        checkButton: {
            minWidth: '100px',
            maxWidth: '100px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '11px',
            background: 'rgba(88,166,255,0.1)',
            border: '1px solid #58a6ff',
            color: '#58a6ff',
            borderRadius: '6px',
            textDecoration: 'none',
            cursor: 'pointer',
            fontWeight: '500',
        },
        jumpContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '16px',
        },
        jumpInput: {
            background: '#0d1117',
            color: '#e6edf3',
            border: '1px solid #30363d',
            borderRadius: '6px',
            padding: '6px 10px',
            fontSize: '13px',
            width: '80px',
            outline: 'none',
        },
        jumpButton: {
            color: '#ffffff',
            background: '#238636',
            border: '1px solid #2ea043',
            borderRadius: '6px',
            padding: '6px 14px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
        },
        chartRow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap',
            marginBottom: '100px',
            marginTop: '20px',
        },
        chartCard: {
            height: '200px',
            width: '90vw',
            maxWidth: '500px',
            background: '#161b22',
            border: '1px solid #21262d',
            borderRadius: '12px',
            padding: '12px',
        },
    }

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <div style={styles.pageContainer}>
                <div style={styles.filterButtonRow}>
                    <div style={styles.filterButton(type == 2)} onClick={() => {
                        setType(2)
                        setSelectedMonth(-1)
                        setChargebackDataWalls(undefined)
                        socket.emit('getChargebacksAdmin', {
                            offers_like: username,
                            page,
                            groupped: grouppedCb,
                            type: 2
                        })
                    }}>Today</div>
                    <div style={styles.filterButton(type == 4)} onClick={() => {
                        setType(4)
                        setSelectedMonth(-1)
                        setChargebackDataWalls(undefined)
                        socket.emit('getChargebacksAdmin', {
                            offers_like: username,
                            page,
                            groupped: grouppedCb,
                            type: 4
                        })
                    }}>Yesterday</div>
                    <div style={styles.filterButton(type == 1)} onClick={() => {
                        setType(1)
                        setSelectedMonth(-1)
                        setChargebackDataWalls(undefined)

                        socket.emit('getChargebacksAdmin', {
                            offers_like: username,
                            groupped: grouppedCb,
                            page,
                            type: 1
                        })
                    }}>This Month</div>
                    <div style={styles.filterButton(type == 3)} onClick={() => {
                        setType(3)
                        setSelectedMonth(-1)
                        setChargebackDataWalls(undefined)

                        socket.emit('getChargebacksAdmin', {
                            offers_like: username,
                            groupped: grouppedCb,
                            page,
                            type: 3,
                            month: new Date().getMonth()-1
                        })
                    }}>Last Month</div>
                    <div style={styles.filterButton(type == 0)} onClick={() => {
                        setType(0)
                        setSelectedMonth(-1)
                        setChargebackDataWalls(undefined)

                        socket.emit('getChargebacksAdmin', {
                            offers_like: username,
                            groupped: grouppedCb,
                            page,
                            type: 0
                        })
                    }}>All</div>
                </div>

                <div style={styles.groupButton(grouppedCb == true)} onClick={() => {
                    const params = {
                        offers_like: username,
                        groupped: !grouppedCb,
                        page,
                        type: type
                    };
                    if (type === 5 && selectedMonth !== -1) {
                        const adjustedMonth = selectedMonth < 0 ? 12 + selectedMonth : selectedMonth;
                        params.type = 3;
                        params.month = adjustedMonth;
                    } else if (type === 3 && selectedMonth === -1) {
                        params.month = new Date().getMonth() - 1;
                    }
                    socket.emit('getChargebacksAdmin', params)
                    setGrouppedCb(!grouppedCb)
                }}>{grouppedCb == true ? "UnGroup" : 'Group'}</div>

                <select
                    value={selectedMonth}
                    style={styles.select}
                    onChange={(e) => {
                        const monthValue = parseInt(e.currentTarget.value);
                        setType(5);
                        setSelectedMonth(monthValue);
                        setChargebackDataWalls(undefined);

                        if (monthValue === -1) {
                            setType(0);
                            socket.emit('getChargebacksAdmin', {
                                offers_like: username,
                                groupped: grouppedCb,
                                page: 1,
                                type: 0
                            });
                        } else {
                            const adjustedMonth = monthValue < 0 ? 12 + monthValue : monthValue;
                            socket.emit('getChargebacksAdmin', {
                                offers_like: username,
                                groupped: grouppedCb,
                                page: 1,
                                type: 3,
                                month: adjustedMonth
                            });
                        }
                    }}>
                    <option value="-1">Select Month</option>
                    {[...Array(12)].map((_, i) => {
                        const monthIndex = new Date().getMonth() - i;
                        const adjustedIndex = monthIndex < 0 ? 12 + monthIndex : monthIndex;
                        return (
                            <option key={i} value={monthIndex}>
                                {months[adjustedIndex]}
                            </option>
                        );
                    })}
                </select>

                <div style={styles.statsRow}>
                    {userProfile.cbAmount != undefined ?
                        <div style={styles.statCard}>
                            <p style={styles.statValue}>
                                {numberWithCommas(userProfile.cbAmount)}
                            </p>
                            <p style={styles.statLabel}>Total chargebacks</p>
                        </div>
                        : <Skeleton style={{ width: '160px', height: '70px', borderRadius: '12px' }} />}
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{...styles.statCard, borderLeft: '3px solid #d29922'}}>
                            <p style={styles.statValue}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={styles.statLabel}>Count chargebacks</p>
                        </div>
                        : <Skeleton style={{ width: '160px', height: '70px', borderRadius: '12px' }} />}
                </div>

                <div style={styles.tableContainer}>
                    <p style={styles.tableTitle}>Chargebacks</p>
                    <div>
                        <input
                            style={styles.searchInput}
                            onChange={(e) => {
                                setUsername(e.currentTarget.value)
                                setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

                                const params = {
                                    offers_like: e.currentTarget.value.toLowerCase(),
                                    page: 1,
                                    groupped: grouppedCb,
                                    type: type
                                };
                                if (type === 5 && selectedMonth !== -1) {
                                    const adjustedMonth = selectedMonth < 0 ? 12 + selectedMonth : selectedMonth;
                                    params.type = 3;
                                    params.month = adjustedMonth;
                                } else if (type === 3 && selectedMonth === -1) {
                                    params.month = new Date().getMonth() - 1;
                                }
                                socket.emit('getChargebacksAdmin', params)
                            }}
                            type="text"
                            name="amount"
                            placeholder="Search by offer name"
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <div style={styles.tableHeaderRow}>
                            {grouppedCb == true ? <>
                                <div style={styles.tableHeaderCell('250px')}>Name</div>
                                <div style={styles.tableHeaderCell('100px')}>Wall</div>
                                <div style={styles.tableHeaderCell('150px')}>Amount</div>
                                <div style={styles.tableHeaderCell('150px')}>Count</div>
                                <div style={styles.tableHeaderCell('100px')}>Total $</div>
                                <div style={styles.tableHeaderCell('100px')}>Category</div>
                            </> : <>
                                <div style={styles.tableHeaderCell('50px')}>ID</div>
                                <div style={styles.tableHeaderCell('250px')}>Name</div>
                                <div style={styles.tableHeaderCell('100px')}>Wall</div>
                                <div style={styles.tableHeaderCell('150px')}>Amount</div>
                                <div style={styles.tableHeaderCell('100px')}>Date</div>
                                <div style={styles.tableHeaderCell('100px')}>Category</div>
                                <div style={{...styles.tableHeaderCell('100px'), maxWidth: '100px'}}>Check</div>
                            </>}
                        </div>
                    </div>

                    {earnings.map((earning, i) => {
                        return (
                            <div key={i} style={styles.tableRow}>
                                {grouppedCb == true ? <>
                                    <div style={styles.tableCellPrimary('250px')}>{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('100px')}>{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.amount || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.c || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{(earning.amount == undefined ? '' : '$' + numberWithCommas(((parseFloat(earning.amount.split("$").join('')) * earning.c) / 0.6).toFixed(2))) || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.category || <Skeleton style={{ width: '30px' }} />}</div>
                                </> : <>
                                    <div style={styles.tableCell('50px')}>{earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCellPrimary('250px')}>{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('100px')}>{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.amount || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.date || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={styles.tableCell('150px')}>{earning.category || <Skeleton style={{ width: '30px' }} />}</div>
                                    <Link to={`/pluto/user/${earning.user_id}`} style={styles.checkButton}>Check User</Link>
                                </>}
                            </div>
                        )
                    })}
                </div>

                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    const params = {
                        offers_like: username,
                        page,
                        groupped: grouppedCb,
                        type: type
                    };
                    if (type === 5 && selectedMonth !== -1) {
                        const adjustedMonth = selectedMonth < 0 ? 12 + selectedMonth : selectedMonth;
                        params.type = 3;
                        params.month = adjustedMonth;
                    } else if (type === 3 && selectedMonth === -1) {
                        params.month = new Date().getMonth() - 1;
                    }
                    socket.emit('getChargebacksAdmin', params)
                }} />}

            </div>
            <div style={styles.jumpContainer}>
                <input onKeyDown={(e) => {
                    if (e.key == 'Enter') {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0])
                        const params = {
                            offers_like: username,
                            page: document.getElementById('jumpto').value,
                            groupped: grouppedCb,
                            type: type
                        };
                        if (type === 5 && selectedMonth !== -1) {
                            const adjustedMonth = selectedMonth < 0 ? 12 + selectedMonth : selectedMonth;
                            params.type = 3;
                            params.month = adjustedMonth;
                        } else if (type === 3 && selectedMonth === -1) {
                            params.month = new Date().getMonth() - 1;
                        }
                        socket.emit('getChargebacksAdmin', params)
                    }
                }} type="number" id="jumpto" style={styles.jumpInput} />
                <button onClick={() => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    const params = {
                        offers_like: username,
                        page: document.getElementById('jumpto').value,
                        groupped: grouppedCb,
                        type: type
                    };
                    if (type === 5 && selectedMonth !== -1) {
                        const adjustedMonth = selectedMonth < 0 ? 12 + selectedMonth : selectedMonth;
                        params.type = 3;
                        params.month = adjustedMonth;
                    } else if (type === 3 && selectedMonth === -1) {
                        params.month = new Date().getMonth() - 1;
                    }
                    socket.emit('getChargebacksAdmin', params)
                }} style={styles.jumpButton}>Go to page</button>
            </div>
            <div style={styles.chartRow}>
                <div style={styles.chartCard}>{chargebackData == undefined ? '' : <ChartComp2 title="Chargebacks ($ )" title2="" title3='' title4='' dataLength={24} dataType='month' data={chargebackData.map(x => x.amount)} chartID={"eariusersacm2"} obj={'$'} />}</div>
                <div style={styles.chartCard}>{chargebackDataWalls == undefined ? '' : <ChartComp2 title="Chargebacks ($) Walls" title2="" title3='' title4='' walls={chargebackDataWalls.map(x => x.wall)} dataType='month' data={chargebackDataWalls.map(x => x.amount)} chartID={"eariusersacmwalls"} obj={'$'} />}</div>
            </div>
        </SkeletonTheme>
    )
}

export default PlutoChargebacks
